import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AssetFinancialSummaryDto } from '@proxy/register-service/assets';

@Component({
  selector: 'app-owned-assets',
  templateUrl: './owned-assets.component.html',
  styleUrls: ['./owned-assets.component.scss'],
})
export class OwnedAssetsComponent {
  @Input() data: AssetFinancialSummaryDto;
  @Output() viewClick = new EventEmitter<string>();
}
